import React from 'react'
import ProfilePage from '../modules/Profile/Profile'

const Profile: React.FC = () => {
  return <ProfilePage />
}

export default Profile
